module.exports = __webpack_public_path__ + "img/footer.d2898014.png";